import { render, staticRenderFns } from "./View16.vue?vue&type=template&id=8c6ef786"
import script from "./View16.vue?vue&type=script&lang=js"
export * from "./View16.vue?vue&type=script&lang=js"
import style0 from "./View16.vue?vue&type=style&index=0&id=8c6ef786&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports